import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "../lib/api";

const DISMISS_PREFIX = "berulia_banner_dismissed_"; // gitleaks:allow

export const BANNER_THEMES = {
  ink: "bg-berulia-ink text-berulia-beige",
  rose: "bg-berulia-rose text-berulia-inkdeep",
  sable: "bg-berulia-beigewarm text-berulia-inkdeep",
};

const isDismissed = (id) => {
  try { return localStorage.getItem(DISMISS_PREFIX + id) === "1"; } catch { return false; }
};

/** Announcement bar driven by the banners configured in the back-office.
 *  Shows the first live banner the visitor hasn't dismissed; renders
 *  nothing when the admin has no active banner. */
export default function SiteBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/banners")
      .then(r => {
        if (!alive) return;
        const next = (r.data.banners || []).find(b => !b.dismissible || !isDismissed(b.id));
        setBanner(next || null);
      })
      .catch(() => { /* banner is decorative — stay silent on failure */ });
    return () => { alive = false; };
  }, []);

  if (!banner) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_PREFIX + banner.id, "1"); } catch (e) { /* ignore */ }
    setBanner(null);
  };

  const theme = BANNER_THEMES[banner.theme] || BANNER_THEMES.ink;
  const text = <span className="font-medium">{banner.message}</span>;

  return (
    <div className={`relative ${theme}`}>
      {banner.link ? (
        <Link to={banner.link} data-testid="site-banner" className="block text-center px-10 py-2 text-xs sm:text-sm tracking-wide hover:opacity-90">
          {text}
        </Link>
      ) : (
        <div data-testid="site-banner" className="block text-center px-10 py-2 text-xs sm:text-sm tracking-wide">
          {text}
        </div>
      )}
      {banner.dismissible && (
        <button
          onClick={dismiss}
          aria-label="Fermer la bannière"
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 opacity-70 hover:opacity-100"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
